import { ObservableArray, View } from "binder"
import { TranslatorSelectionPopupViewModel, enums, process } from "./translatorSelectionPopup-viewModel"

export class TranslatorSelectionPopupView extends View<TranslatorSelectionPopupViewModel>{
    GetViewUniqueId(): string {
        return "V-32B2E035-8CAE-4EE6-9C0A-A15681E150FA"
    }
    loadHtml(): string {
        let element = require('./translatorSelectionPopup.html').default;
        let style = require('./translatorSelectionPopup.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set processes(v: ObservableArray<process>) { this._processes = v; } public get processes(): ObservableArray<process> { return this._processes;} private _processes: ObservableArray<process>;
    public set enums(v: ObservableArray<enums>) { this._enums = v; } public get enums(): ObservableArray<enums> { return this._enums;} private _enums: ObservableArray<enums>;
    public set selectedProcess(v: process) { this._selectedProcess = v; } public get selectedProcess(): process { return this._selectedProcess;} private _selectedProcess: process;
    public set selectedEnum(v: enums) { this._selectedEnum = v; } public get selectedEnum(): enums { return this._selectedEnum;} private _selectedEnum: enums;

    confirm(){
        this.dataContext.confirm();
    }
    back(){
        this.dataContext.back();
    }
}
